import React from "react";
import AnimateLine from "../../../common/AnimateLine";
import Breadcrumb from "../../../common/Breadcrumb";
import SubscribArea from "../../../common/SubscribArea";
import ProjectDetailsWrap5 from "../ImpreunapentruAnais/ProjectDetailsWrap5";

function ProjectDetails5() {
  return (
    <>
      <div className="ebrandy-wrap">
        <AnimateLine />
        <Breadcrumb pageName="Împreună pentru Anais" pageTitle="Împreună pentru Anais" />
        <ProjectDetailsWrap5 />
        <SubscribArea />
      </div>
    </>
  );
}

export default ProjectDetails5;
